<div class="error-background">
    <div class="error-message container">
        <h1>Oppsie. The page you are directed is not found. Don't worry, 
            we will redirect you back to the <span><a routerLink="/home">homepage</a></span> in a few seconds!
        </h1>
        <div class="error-img"></div>
    </div>
</div>